export const FETCH_CREDENTIALS = 'FETCH_CREDENTIALS';
export const FETCH_CREDENTIALS_SUCCESS = 'FETCH_CREDENTIALS_SUCCESS';
export const FETCH_CREDENTIALS_ERROR = 'FETCH_CREDENTIALS_ERROR';
export const SHOW_TOAST_NOTIFICATION = 'SHOW_TOAST_NOTIFICATION';
export const HIDE_TOAST_NOTIFICATION = 'HIDE_TOAST_NOTIFICATION';

export const fetchCredentials = () => ({ type: FETCH_CREDENTIALS });
export const showToastNotification = (time, message) => ({
	type: SHOW_TOAST_NOTIFICATION, time: time, message: message
});
export const hideToastNotification = () => ({ type: HIDE_TOAST_NOTIFICATION });
